/**
 * Exposure Modal component module.
 * @module advisor/components/modals/ExposureSecuritiesModal
 *
 */
import React from 'react';
import {connect} from 'react-redux';
import BaseModal from '../types/Base';
import {_removeModal} from '../../../store';
import PropTypes from 'prop-types';
import debug from 'debug';
import ExposureSecuritiesGraph from '../../../../advisor/shared/widgets/containers/ExposureSecuritiesGraph';

const log = debug('circleblack:modals:ExposureSecuritiesModal');

/**
 * ExposureSecuritiesModal
 * @name ExposureSecuritiesModal
 */
const ExposureSecuritiesModal = props => {
  const {content, removeModal} = props;
  const {containerID, category, types, initialType} = content;
  log('rendering');
  return <BaseModal onClose={() => removeModal(content)} title={'Exposure Holdings'} size={'lg'}>
    <ExposureSecuritiesGraph containerID={containerID} category={category} types={types} initialType={initialType}/>
  </BaseModal>;
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  removeModal: modalToRemove => dispatch(_removeModal(modalToRemove)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExposureSecuritiesModal);

ExposureSecuritiesModal.propTypes = {
  removeModal: PropTypes.func.isRequired,
  content: PropTypes.shape({
    containerID: PropTypes.number.isRequired,
    category: PropTypes.string.isRequired,
    types: PropTypes.arrayOf(PropTypes.object).isRequired,
    initialType: PropTypes.string.isRequired,
  }),
};
